import {useIsFocused, useNavigation, useRoute} from '@react-navigation/native';
import React, {useEffect, useRef, useState} from 'react';
import {
   ActivityIndicator,
   Platform,
   StatusBar,
   StyleSheet,
   TouchableOpacity,
   TouchableWithoutFeedback,
   View,
   Dimensions,
   BackHandler,
   Alert,
   Linking,
   TextInput,
} from 'react-native';
//import Video from 'react-native-video';
import Video from '../../components/video';
// import ReactPlayer from 'react-player';
import CustomController from './CustomController';
import {
   getVideoPath,
   getReviewQuestionAnswerData,
   SAVE_TRAINING_PAGE,
   getFinalQuestionAnswerData,
   isNewAPI,
   checkFileExists,
   TutorialShown,
   rotatePlayerScreenMsg,
   getFinalTestParams,
   UPDATE_TEST_RECORD,
   COURSE_ROOT_ITEM,
   isMacOS,
   ActivityLoaderColor,
   setWebNavTitle,
   isiOS,
   GET_DASHBOARD_DATA,
   aslCloseHandler,
   getMediaPath,
} from '../../utils/utils';
import Orientation from 'react-native-orientation-locker';
import {
   selectLandscapeSmallWebView,
   selectScreenOrientation,
   setShowLandscapeMsg,
} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector, useDispatch} from 'react-redux';
import ReviewQuestionScreen from '../reviewQuestions/ReviewQuestionScreen';
import {selectReviewQuestionAnswer} from '../../redux/slices/ReviewQuestionsSlice';
import {selectedModuleIndex} from '../../redux/slices/ModuleIndexSlice';
import {
   selectedScratchPadRecord,
   setCurrentPageWithRespectiveModule,
} from '../../redux/slices/ScratchPadRecordSlice';
import {
   apiPostRequest,
   showTokenExpireAlertWeb,
} from '../../service/network_access';
import FeedBackView from './FeedBackView';
import {selectAuthData} from '../../redux/slices/AuthSlice';
import BottomControll from './BottomControll';
import CourseSlideEventOnVideo from '../../utils/CourseSlideEventOnVideo';
import logger from '../../utils/logger';
import {NativeModules} from 'react-native';
import WebView from '../../components/webview';
import {
   getCourseData,
   getModuleCompetedCount,
   setIsEnrolledPageReload,
} from '../../redux/slices/EnrolledCourseDataSlice';
//import PdfVieweWindows from '../../utils/pdfVieweWindows';
import CustomAlert from '../../components/custom-alert/index.web';
//const VideoPlayerView = requireNativeComponent('VideoPlayerView');
//const VideoPlayerView = requireNativeComponent('VideoPlayerView');
const VideoPlayerViewManager = NativeModules.VideoPlayerViewManager;
const isDesktop = Platform.OS === 'macos' || Platform.OS === 'windows'; //The video player is same for windows and mac
const isWeb = Platform.OS === 'web';
const isWindows = Platform.OS === 'windows';
import TutorialOverlayView from '../reviewQuestions/TutorialOverlayView';
const isMacos = Platform.OS === 'macos';
import RNFS from '../../components/fs';
import {selectDownloadPreference} from '../../redux/slices/DownloadPreferenceSlice';
import {setIsDashboardRefreshRequired} from '../../redux/slices/DashboardRefreshSlice';
import {
   removeSaveItem,
   retrieveAppData,
   storeAppData,
} from '../../utils/preference';
import {
   isMobile,
   isTablet,
   isIOS as isWebIOS,
   isAndroid as isWebAndroid,
} from 'react-device-detect';
import CustomToast from '../../components/custom-toast/index.web';
import {
   setResponseAlertData,
   getResponseAlertData,
   clearResponseAlertData,
} from '../../redux/slices/ResponseAlertSlice';
import {setCommingFromDetails} from '../../redux/slices/TrackRoot';
import NorcatWebAlert from './NorcatWebAlert';
import {setPressClose} from '../../redux/slices/AslSlice';

const PlayerScreen = () => {
   const dispatch = useDispatch();
   const userAgent = window.navigator.userAgent;
   const iPhoneBrowser = userAgent?.includes('iPhone OS');
   const course = useRoute().params;
   const navigation = useNavigation();
   const videoRef = React.useRef(null);
   const [duration, setDuration] = useState(0);
   const [currentTime, setCurrentTime] = useState(0);
   const [currentSlide, setCurrentSlide] = useState(0);
   const [title, setTitle] = useState('');
   const [totalSlide, setTotelSlide] = useState(0);
   const [volume, setVolume] = React.useState(1); // initial volume is set to 1.0
   const [isLoading, setIsLoading] = useState(true);
   const [isPlaying, setIsPlaying] = useState(iPhoneBrowser ? false : true);
   const [showControl, setShowControl] = useState(true);
   const [showFeedBackScreen, setShowFeedBackScreen] = useState(false);
   const [showOverlay, setShowOverlay] = useState(false);
   const [isVideo, setIsVideo] = useState(true);
   const [eventNode, setEventNode] = useState(true);
   const isIOS = Platform.OS === 'ios';
   const isAndroid = Platform.OS === 'android';
   const authData = useSelector(selectAuthData);
   const [isContinueTiered, setIsContinueTiered] = useState(false);
   const [videoSource, setVideoSource] = useState({
      uri: '',
   });
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const reviewQuesAns = useSelector(selectReviewQuestionAnswer);
   const moduleIndex = useSelector(selectedModuleIndex);
   const scratchPadString = useSelector(selectedScratchPadRecord);
   const scratchPad = JSON.parse(scratchPadString);
   const scratchPadRecord = isNewAPI
      ? scratchPad.ScratchPadRecordsList
      : scratchPad.scratchPadRecord;
   var timoutID = '';
   const [isLandscape, setIsLandscape] = useState(false);
   const [finalQuesAnsData, setFinalQuesAnsData] = useState();
   const [isReviewTest, setReviewTest] = useState(false);
   const [isFinaltest, setFinalTest] = useState(false);
   const [videoWidth, setVideoWidth] = useState();
   const [videoHeight, setVideoHeight] = useState();
   const [playerWidth, setPlayerWidth] = useState();
   const [playerHeight, setPlayerHeight] = useState();
   const [webTitle, setWebTitle] = useState('Player');

   const [percentageRequirement, setPercentageRequirement] = useState('');
   const screenWidth = Dimensions.get('window').width;
   const screenHeight = Dimensions.get('window').height;
   const [screenLandscapeWidth, setScreenLandscapeWidth] = useState(
      Math.max(screenWidth, screenHeight),
   );
   const [screenLandscapeHeight, setScreenLandscapeHeight] = useState(
      Math.min(screenHeight, screenWidth),
   );
   const moduleId = isNewAPI
      ? scratchPadRecord[moduleIndex].ModuleNumber
      : scratchPadRecord[moduleIndex].ModuleID;

   const pageNumber = isNewAPI
      ? scratchPadRecord[moduleIndex].ModulePageNumber
      : scratchPadRecord[moduleIndex].PageNumber;
   const webViewRef = React.useRef(null);
   const [isTutorialVisible, setIsTutorialVisible] = useState(false);
   const [isFinalTestStarted, setFinalTestStarted] = useState(false);
   // const isNextSlideAvailable = checkAvailabilityOfNextSlid(scratchPadRecord);
   const isNextSlideAvailable = checkAvailabilityOfNextSlid();
   const [isLocalFileExists, setIsLocalFileExist] = useState(false);
   const [localVideoSource, setLocalVideoSource] = useState('');
   const isDownloadPreferenceEnabled = useSelector(selectDownloadPreference);
   const [isInitialLaunch, setIsInitialLaunch] = useState(true);
   const enrolledCourse = useSelector(getCourseData);
   const webAlert = useSelector(getResponseAlertData);
   const CourseSaveCount = enrolledCourse.courseSaveCount;
   const [isFullScreen, setIsFullScreen] = useState(false);
   const [isAndroidFullScreen, setIsAndroidFullscreen] = useState(
      isWebAndroid && !isTablet ? true : false,
   );
   const webLandscapeVideoDecValue = isTablet ? 109 : 91;
   const [webLandscapeVideoHeight, setWebLandscapeVideoHeight] = useState(
      isWeb
         ? window.innerHeight - webLandscapeVideoDecValue
         : Dimensions.get('screen').height - webLandscapeVideoDecValue,
   );
   const isPreTeastEnable = course.isPreTeastEnable;
   const isScreenFocused = useIsFocused();
   const getMCompetedCount = useSelector(getModuleCompetedCount);
   const [isMCOnPlayerScreen, setMCOnPlayerScreen] = useState(false);
   const [isApiLoading, setApiLoading] = useState(false);
   useEffect(() => {
      setWebNavTitle(navigation, webTitle);
   }, [navigation, webTitle]);

   useEffect(() => {
      setWebTitle(showFeedBackScreen ? 'Slide Feedback' : 'Player');
      if (showFeedBackScreen) {
         aslCloseHandler(dispatch);
      }
   }, [showFeedBackScreen]);

   useEffect(() => {
      if (!showOverlay && !isContinueTiered && eventNode) {
         tigerTheCourseEvent(currentTime);
      }
   }, [currentTime, showOverlay, isContinueTiered, eventNode]);

   useEffect(() => {
      dispatch(setCommingFromDetails(false));
      if ((isWindows && isScreenFocused) || !isWindows) {
         retrieveAppData(TutorialShown)
            .then(data => {
               if (data === '') {
                  setIsTutorialVisible(true);
               }
            })
            .catch(error => {
               logger('error::', error);
            });
         const unsub = navigation.addListener('focus', () => {
            // The screen is focused
            // Call any action
            setTotelSlide(course.courseModuleSlide?.length);
            changeSlideData(course.index);
            if (isLandscapeMode !== true) {
               setTimeout(() => {
                  Orientation.lockToLandscape();
               }, 500);
            }
         });
         const backHandler = BackHandler.addEventListener(
            'hardwareBackPress',
            handleBackButton,
         );

         if (isWeb) {
            dispatch(setShowLandscapeMsg({showLandscapeMsg: false}));
            window.addEventListener('keydown', handleKeyPress);
            if (
               (!isLandscapeMode || isLandscapeSmallWebView) &&
               !iPhoneBrowser &&
               !(isTablet && isWebIOS)
            ) {
               toggleFullScreen();
            }
         }
         if (isMacos) {
            NativeModules.SpacebarModule.startListening(onKeydown => {
               setIsPlaying(!isPlaying);
               handleMacPlayPause();
            });
         }
         return () => {
            if (isMacos) {
               NativeModules.SpacebarModule.removeListening();
            }
            backHandler.remove();
            if (!isLandscapeMode) {
               unsub();
               setTimeout(() => {
                  Orientation.lockToPortrait();
               }, 500);
            }
            if (isWeb) {
               dispatch(setShowLandscapeMsg({showLandscapeMsg: true}));
               window.removeEventListener('keydown', handleKeyPress);
               if (
                  !isLandscapeMode &&
                  screen &&
                  screen.orientation &&
                  screen.orientation.unlock
               ) {
                  screen.orientation.unlock();
               }
            }
         };
      }
   }, []);
   useEffect(() => {
      if (isWeb && webAlert.pressOk) {
         navigation.pop(2);
         dispatch(clearResponseAlertData());
      }
   }, [webAlert]);
   const handleKeyPress = event => {
      if (event.code === 'Space') {
         togglePlay();
      }
   };

   const togglePlay = () => {
      setIsPlaying(prevState => !prevState);
   };

   function checkAvailabilityOfNextSlid() {
      const savePage = parseInt(
         isNewAPI
            ? scratchPadRecord[moduleIndex].ModulePageNumber
            : scratchPadRecord[moduleIndex].PageNumber,
      );
      const currentPage = parseInt(currentSlide);
      const isNextAvailable = savePage - currentPage > 1;
      return isNextAvailable;
   }

   function hideControl() {
      setShowControl(false);
   }

   const handleBackButton = () => {
      if (showFeedBackScreen) {
         setShowFeedBackScreen(false);
         setShowControl(false);
      } else {
         navigation.goBack();
      }
      return true;
   };

   function callSaveTrainingPageApi(
      ScratchKey,
      ModuleNumber,
      PageNumber,
      onCallBack,
   ) {
      const reqParms = {
         theData: JSON.stringify({
            ScratchKey: ScratchKey,
            ModuleNumber: ModuleNumber,
            PageNumber: PageNumber,
            EmployeeKey: authData.EmployeeKey,
         }),
      };
      apiPostRequest({
         url: SAVE_TRAINING_PAGE,
         parms: reqParms,
      })
         .then(res => {
            // setIsApiLoading(false);
            if (res && res.StatusResult) {
               onCallBack();
               // const user = {
               //   isLoggedIn: true,
               //   userName: res.ACMEmployeeFirstName,
               // };
               // dispatch(setSignIn(user));
            } else if (typeof res === 'string') {
               if (isWeb && isVideo) {
                  setIsPlaying(false);
               }
               if (isWeb) {
                  showTokenExpireAlertWeb(res);
               } else {
                  alert(res);
               }
               logger('Exception Response:: ' + JSON.stringify(res));
               // setIsError(true);
               // setErrorMessage(res);
            } else {
               if (isWeb && isVideo) {
                  setIsPlaying(false);
               }
               logger('Error Response:: ' + JSON.stringify(res));
               // setIsError(true);
               // setErrorMessage('Please verify your login credential');
            }
         })
         .catch(error => {
            logger('error::', error);
         });
   }

   function startMacServer(fileName) {
      if (isMacos) {
         NativeModules.HttpServerModule.startServer(fileName);
      }
   }

   function changeSlideData(index) {
      setShowOverlay(false);
      setIsContinueTiered(false);
      setEventNode(
         course.courseModuleSlide[index]?.CourseSlideEventNode
            ?.CourseSlideEventNode || []
      );
   setCurrentTime(0);
      //index = course.courseModuleSlide.length - 1; //For testing purpus - direct jump to last slide of module
      callSaveTrainingPageApi(
         scratchPadRecord[moduleIndex].ScratchPadKey,
         moduleId,
         isPreTeastEnable ? 1 : index + 1,
         () => {
            const pageNumber = isPreTeastEnable ? 1 : index + 1;
            dispatch(
               setCurrentPageWithRespectiveModule({
                  pageNumber: pageNumber,
                  moduleID: moduleIndex,
               }),
            );
            dispatch(setIsDashboardRefreshRequired(true));
            logger(`SAVE_TRAINING_PAGE :: ${SAVE_TRAINING_PAGE}`);
         },
      );
      setCurrentSlide(isPreTeastEnable ? 1 : index);
      setCurrentTime(0);
      setTitle(course.courseModuleSlide[index].SlideName);
      if (course.courseModuleSlide[index].SlideVideoClipString !== '') {
         setEventNode(
            course.courseModuleSlide[index].CourseSlideEventNode
               .CourseSlideEventNode,
         );
         setIsLoading(true);
         setIsVideo(true);
         setWebTitle('Player');
         /*const newVideoUrl =
            getVideoPath() +
            course.courseData.courseNameID +
            course.courseModuleSlide[index].SlideVideoClipString;*/
         const newVideoUrl = getVideoPath(
            course.courseData.courseNameID,
            course.courseModuleSlide[index].SlideVideoClipString,
         );
         if (isDesktop && isDownloadPreferenceEnabled === 'true') {
            const filename =
               course.courseData.courseNameID +
               course.courseModuleSlide[index].SlideVideoClipString;
            checkFileExists(filename)
               .then(async exists => {
                  //To do play the video from file system on mac
                  if (exists) {
                     const documentDirectory = RNFS.DocumentDirectoryPath;
                     const filePath = `${documentDirectory}/Norcat/${filename}`;
                     logger('video path: file://' + filePath);
                     if (isWindows) {
                        setVideoSource({uri: 'file://' + filePath});
                        setIsPlaying(true);
                     } else {
                        const name = course.courseModuleSlide[
                           index
                        ].SlideVideoClipString.replace('/videos', '');
                        const playerPath = getMediaPath(
                           'video',
                           course.courseData.courseNameID,
                           '/video' + name,
                        );

                        try {
                           const fileContent = await RNFS.readFile(
                              playerPath,
                              'base64',
                           );
                           const ext = playerPath.split('.').pop();
                           const dataUri = `data:video/${ext};base64,${fileContent}`;
                           setVideoSource({uri: dataUri});
                           setIsPlaying(true);
                        } catch (error) {
                           logger('Error reading video file:', error);
                        }
                     }
                  } else {
                     logger('playing server video');
                     setVideoSource({uri: newVideoUrl});
                     setIsPlaying(true);
                  }
               })
               .catch(error => {
                  logger('error::', error);
               });
         } else {
            logger('playing server video');
            setVideoSource({uri: newVideoUrl});
            if (isInitialLaunch && iPhoneBrowser) {
               setIsInitialLaunch(false);
               setIsPlaying(false);
            } else {
               setIsPlaying(true);
            }
         }
      } else {
         findQuestionAnswerData(index);
         setIsLoading(false);
         setIsVideo(false);
         setShowControl(true);
      }
   }

   function findQuestionAnswerData(index) {
      const isTestQuestionExists =
         course.courseModuleSlide[index].courseModuleSlideTestSettings
            .isTestQuestion;
      const isFinalQuestionExists =
         course.courseModuleSlide[index].courseModuleSlideTestSettings
            .isFinalTest;

      //Are we now on a Review Question?
      if (isTestQuestionExists === 'true') {
         const questionId =
            course.courseModuleSlide[index].courseModuleSlideTestSettings
               .QuestionID;
         const finalQuesAnsData = getReviewQuestionAnswerData(
            reviewQuesAns,
            moduleIndex,
            questionId,
         );
         setReviewTest(true);
         setFinalQuesAnsData(finalQuesAnsData);
      }
      if (
         course.isModuleCompleted &&
         course.courseModuleSlide[index].courseModuleSlideTestSettings
            .isFinalTest === 'true'
      ) {
         //Set Web alert data
         if (Platform.OS === 'web') {
            dispatch(
               setResponseAlertData({
                  showAlert: true,
                  title: 'Alert!',
                  message: 'You have already completed the test',
                  callbackType: 'TEST_ALREADY_COMPLETED',
                  callback: () => {
                     navigation.pop(2);
                  },
               }),
            );
         } else {
            Alert.alert('Alert!', 'You have already completed the test', [
               {
                  text: 'OK',
                  onPress: () => {
                     navigation.pop(2);
                  },
               },
            ]);
         }
         /* Platform.OS === 'web'
            ? setShowAlertData({
                 showAlert: true,
                 title: 'Alert!',
                 message: 'You have already completed the test',
                 callback: () => {
                    navigation.pop(2);
                 },
              })
            : Alert.alert('Alert!', 'You have already completed the test', [
                 {
                    text: 'OK',
                    onPress: () => {
                       navigation.pop(2);
                    },
                 },
              ]); */
         return;
      }
      //Are we now on a Final Test?
      if (isFinalQuestionExists === 'true') {
         const isUsingAllQuestions =
            course.courseModuleSlide[index].courseModuleSlideTestSettings
               .isUsingAllQuestions;
         const questionCount =
            course.courseModuleSlide[index].courseModuleSlideTestSettings
               .QuestionCount;
         const percentageRequired = isPreTeastEnable
            ? course.courseModuleSlide[index].courseModuleSlideTestSettings
                 .PreTestScorePercentageRequirement
            : course.courseModuleSlide[index].courseModuleSlideTestSettings
                 .ScorePercentageRequirement;
         setPercentageRequirement(percentageRequired);
         var allQuestions = false;
         if (isUsingAllQuestions === 'true') {
            allQuestions = true;
         } else {
            allQuestions = false;
         }
         generateFinalQuestionsAnswers(allQuestions, questionCount);
         setReviewTest(false);
         setFinalTest(true);
      }
   }

   function generateFinalQuestionsAnswers(allQuestions, questionCount) {
      const finalQuesAnsData = getFinalQuestionAnswerData(
         reviewQuesAns,
         allQuestions,
         moduleIndex,
         questionCount,
      );
      setFinalQuesAnsData(finalQuesAnsData);
   }

   const handleBuffer = ({isBuffering}) => {
      // logger(isBuffering);
      setIsLoading(isBuffering);
   };

   const handleVolumeChange = newVolume => {
      setVolume(newVolume);
      if (isDesktop) {
         setVolumeForMac(newVolume);
      }
   };

   const previousSlide = async () => {
      winFocus();
      // videoRef.current.seek(currentTime - 10); // Rewind 10 seconds
      if (currentSlide > 0) {
         var slide = currentSlide;
         changeSlideData(slide - 1);
         if (isVideo) {
            pauseMacVideo();
         }
      }
   };

   const nextSlide = async () => {
      winFocus();
      // videoRef.current.seek(currentTime + 10); // Fast-forward 10 seconds
      if (currentSlide < totalSlide - 1) {
         var slide = currentSlide;
         changeSlideData(slide + 1);
         if (isVideo) {
            pauseMacVideo();
            setWebTitle('Player');
         }
      } else {
         callSubmitTestAPI();
      }
   };
   const message = 'Current module has been completed.';
   function callSubmitTestAPI() {
      const message = 'Current module has been completed.';
      const scratchPadRecord = isNewAPI
         ? scratchPad.ScratchPadRecordsList
         : scratchPad.scratchPadRecord;
      let submitTestParams = getFinalTestParams(
         scratchPadRecord,
         authData,
         moduleIndex,
         '0',
         '0',
         'C',
         '',
         CourseSaveCount,
      );
      apiPostRequest({url: UPDATE_TEST_RECORD, parms: submitTestParams})
         .then(res => {
            dispatch(setIsDashboardRefreshRequired(true));
            retrieveAppData(COURSE_ROOT_ITEM)
               .then(res => {
                  const item = JSON.parse(res);
                  const wwwCourse = item.courseNameID + '/manifest.xc';
                  removeSaveItem(wwwCourse)
                     .then(() => {
                        if (Platform.OS === 'web') {
                           setMCOnPlayerScreen(true);
                        } else {
                           Alert.alert('Alert!', message, [
                              {
                                 text: 'OK',
                                 onPress: () => {
                                    refreshEnrolledCourses();
                                 },
                              },
                           ]);
                        }
                     })
                     .catch(error => {
                        logger('error::', error);
                     });
               })
               .catch(error => {
                  logger('error::', error);
               });
         })
         .catch(error => {
            logger('error::', error);
         });
   }
   function refreshEnrolledCourses() {
      setApiLoading(true);
      const reqParms = {
         theData: JSON.stringify({
            EmployeeKey: authData.EmployeeKey,
         }),
      };
      apiPostRequest({url: GET_DASHBOARD_DATA, parms: reqParms}).then(res => {
         if (res !== null && res !== undefined && typeof res !== 'string') {
            //Filter the cousers of version 9
            const filteredCourses = res.UserTrainingEnrolledRecordsList.filter(
               course => course.courseVersion != '9',
            ).filter(
               course =>
                  course.courseNameID === enrolledCourse.courseNameID &&
                  course.pid === enrolledCourse.pid,
            );
            var courseData;
            if (filteredCourses.length == 0) {
               courseData = enrolledCourse;
            } else {
               courseData = filteredCourses[0];
            }
            setApiLoading(false);
            if (getMCompetedCount <= 1) {
               /**
                * This is the case the module is last one and not having any final test/pre test
                */
               navigation.pop(3);
            } else {
               /**
                * This is the case the module is not last one and not having any final test/pre test
                */
               navigation.pop(3);
               navigation.navigate('courseLoading', {
                  courseData: courseData,
               });
            }
         }
      });
   }
   function toggleFullScreen() {
      setWebLandscapeVideoHeight(
         isWeb
            ? window.innerHeight - webLandscapeVideoDecValue
            : Dimensions.get('screen').height - webLandscapeVideoDecValue,
      );
      const videoComponent = document.documentElement;
      if (isWeb && videoComponent) {
         if (!isFullScreen || !document?.fullscreenElement) {
            setIsFullScreen(true);
            setIsAndroidFullscreen(true);
            if (videoComponent.requestFullscreen) {
               videoComponent.requestFullscreen();
            } else if (videoComponent.mozRequestFullScreen) {
               videoComponent.mozRequestFullScreen();
            } else if (videoComponent.webkitRequestFullscreen) {
               videoComponent.webkitRequestFullscreen();
            } else if (videoComponent.msRequestFullscreen) {
               videoComponent.msRequestFullscreen();
            }
            if (
               !isLandscapeMode &&
               screen &&
               screen.orientation &&
               screen.orientation.lock
            ) {
               screen.orientation
                  .lock('landscape-primary')
                  .then(() => {
                     logger(`Locked to ${screen.orientation.type}\n`);
                  })
                  .catch(error => {
                     logger(`${error}\n`);
                  });
            }
         } else {
            if (
               !isLandscapeMode &&
               screen &&
               screen.orientation &&
               screen.orientation.unlock
            ) {
               screen.orientation.unlock();
            }
            !(isLandscapeSmallWebView || isLandscapeMode) &&
               setIsPlaying(false);
            setIsFullScreen(false);
            setIsAndroidFullscreen(false);
            closeFullscreen();
         }
      }
   }
   function closeFullscreen() {
      const videoComponent = document;
      if (isFullScreen && videoComponent?.fullscreenElement) {
         if (videoComponent?.exitFullscreen) {
            videoComponent.exitFullscreen();
         } else if (videoComponent?.webkitExitFullscreen) {
            /* Safari */
            videoComponent.webkitExitFullscreen();
         } else if (videoComponent?.msExitFullscreen) {
            /* IE11 */
            videoComponent.msExitFullscreen();
         }
         setWebLandscapeVideoHeight(
            isWeb
               ? window.innerHeight - webLandscapeVideoDecValue
               : Dimensions.get('screen').height - webLandscapeVideoDecValue,
         );
      }
   }
   const seekTO = value => {
      if (isDesktop) {
         if (webViewRef.current) {
            setCurrentTime(value);
            webViewRef.current.injectJavaScript(
               `norcatVideo.currentTime = ${value};`,
            );
         }
      } else {
         if (isWeb && isVideo) {
            const parsedValue =
               value < 1 ? Math.round(value) : parseFloat(value);
            videoRef.current?.seekTo(parsedValue);
         }
         if (!isWeb && isVideo && videoRef.current.seek) {
            videoRef.current.seek(value);
         }
      }
   };

   const onLoad = data => {
      hideControl();
      setIsLoading(false);
      setDuration(data.duration);
      setVideoWidth(data.naturalSize.width);
      setVideoHeight(data.naturalSize.height);
      logger(`VIDEO: Width :: ${videoWidth}`);
      logger(`VIDEO: Height :: ${videoHeight}`);
      setScreenLandscapeWidth(Math.max(screenWidth, screenHeight));
      setScreenLandscapeHeight(Math.min(screenHeight, screenWidth));
   };

   const onLayout = event => {
      const {width, height} = event.nativeEvent.layout;
      setPlayerWidth(width);
      setPlayerHeight(height);
      logger(`Actual pWidth :: ${width}`);
      logger(`Actual pHeight :: ${height}`);
      setScreenLandscapeWidth(Math.max(screenWidth, screenHeight));
      setScreenLandscapeHeight(Math.min(screenHeight, screenWidth));
   };
   var first = 5;
   const onProgress = (data) => {
      const { currentTime } = data;
      logger(data);
      setCurrentTime(data.currentTime);
      tigerTheCourseEvent(currentTime);
      // if (first == 5) {
      //   if (
      //     course.courseModuleSlide[currentSlide].CourseSlideEventNode
      //       .CourseSlideEventNode.length >= 2
      //   ) {
      //     first=6;
      //     setShowOverlay(true);
      //     // setIsPlaying(false);
      //   }
      // }
   };
   function tigerTheCourseEvent(time) {
      const videoRunningTime = Math.round(time);
      if (
         course.courseModuleSlide[currentSlide].CourseSlideEventNode
            .CourseSlideEventNode.length >= 2
      ) {
         const ventRootNode =
            course.courseModuleSlide[
               currentSlide
            ].CourseSlideEventNode.CourseSlideEventNode.slice(-1);
         ventRootNode.map((data, index) => {
            const timePos = Math.ceil(parseFloat(data._timePos));
            if (
               videoRunningTime === timePos &&
               !isContinueTiered
            ) {
               setShowOverlay(true);
               logger("I was supposed to pause here");
               setIsPlaying(false);
               pauseMacVideo();
               hideControl();
            }
            return;
         });
      }
   }

   function handleControls() {
      winFocus();
      logger('tapped show hide controls');
      setShowControl(!showControl);
   }

   function handlePlayPause() {
      if (isVideo) {
         setIsPlaying(!isPlaying);
      }
      handleMacPlayPause();
   }

   function goBackToSlides() {
      if (!isLandscapeMode) {
         setTimeout(() => {
            // Orientation.lockToPortrait();
         }, 500);
      }
      navigation.pop(1);
   }
   function handleMacPlayPause() {
      winFocus();
      if (isVideo && isDesktop) {
         isPlaying ? pauseMacVideo() : playMacVideo();
      }
   }

   const onLoadEnd = () => {
      hideControl();
      setIsLoading(false);
   };

   // Function to handle volume change
   const setVolumeForMac = volume => {
      const script = `document.getElementById('norcatVideo').volume = ${volume};true`;
      if (webViewRef.current) {
         webViewRef.current.injectJavaScript(script);
      }
   };

   const playMacVideo = () => {
      const script = "document.getElementById('norcatVideo').play()";
      if (webViewRef.current) {
         webViewRef.current.injectJavaScript(script);
      }
   };

   const pauseMacVideo = () => {
      if (isDesktop) {
         const script = "document.getElementById('norcatVideo').pause()";
         if (webViewRef.current) {
            webViewRef.current.injectJavaScript(script);
         }
      }
   };

   const onLoadMacVideo = data => {
      const {duration, width, height} = data;
      setIsLoading(false);
      if (!isNaN(duration)) {
         setDuration(duration);
      }
      if (!isNaN(width) && !isNaN(height)) {
         setVideoWidth(width);
         setVideoHeight(height);
         logger(`VIDEO: Width :: ${width}`);
         logger(`VIDEO: Height :: ${height}`);
         setScreenLandscapeWidth(Math.max(screenWidth, screenHeight));
         setScreenLandscapeHeight(Math.min(screenHeight, screenWidth));
      }
   };
   const handleProgress = progress => {
      setCurrentTime(progress.playedSeconds);
      tigerTheCourseEvent(progress.playedSeconds);
   };
   const handleDuration = duration => {
      logger(duration);
      setDuration(duration);
   };
   const handleReadyWeb = player => {
      hideControl();
      setIsLoading(false);
      setVideoWidth(player.getInternalPlayer().videoWidth);
      setVideoHeight(player.getInternalPlayer().videoHeight);
      setScreenLandscapeWidth(Math.max(screenWidth, screenHeight));
      setScreenLandscapeHeight(Math.min(screenHeight, screenWidth));
   };
   function setPlayerDimensions() {
      const vWidth = window.innerWidth;
      const vHeight = window.innerHeight;
      setPlayerHeight(vHeight);
      setPlayerWidth(vWidth);
   }
   useEffect(() => {
      setPlayerDimensions();
   }, [isLandscapeSmallWebView, isLandscapeMode]);

   useEffect(() => {
      const handleResize = () => {
         setPlayerDimensions();
         setWebLandscapeVideoHeight(
            isWeb
               ? isLandscapeMode
                  ? window.innerHeight - webLandscapeVideoDecValue
                  : window.innerHeight
               : Dimensions.get('screen').height - webLandscapeVideoDecValue,
         );
      };
      let dimensionResizeWeb;
      if (isWeb) {
         dimensionResizeWeb = Dimensions.addEventListener(
            'change',
            handleResize,
         );
         window.addEventListener('resize', handleResize);
      }

      return () => {
         if (isWeb) {
            dimensionResizeWeb.remove();
            window.removeEventListener('resize', handleResize);
         }
      };
   }, []);
   const [showAlertData, setShowAlertData] = useState({
      showAlert: false,
      title: 'Alert!',
      message: '',
      callback: null,
   });

   function onValueChange(value) {
      if (isNextSlideAvailable === true) {
         // setCurrentTime(value);
         seekTO(value);
      }
   }

   const handleKeyDown = event => {
      winFocus();
      logger('keydown');
      // Assuming event.nativeEvent.key is used to capture the key code
      if (event.nativeEvent.key === ' ' && (isMacos || isWindows)) {
         setIsPlaying(!isPlaying);
         setShowControl(true);
         handleMacPlayPause();
         // webViewRef.current?.injectJavaScript('document.querySelector("video").paused ? document.querySelector("video").play() : document.querySelector("video").pause();');
      } else {
         !isWeb ? handleControls() : null;
      }
   };

   const inputRef = useRef(null);
   function winFocus() {
      if (isVideo && isWindows && inputRef) {
         inputRef.current.focus();
      }
   }
   return (
      <View
         style={[
            styles.container,
            {
               ...Platform.select({
                  web: {
                     flex: null,
                     height:
                        isLandscapeMode && !isTablet
                           ? '100vh'
                           : window?.innerHeight ?? '100vh',
                     justifyContent: 'space-between',
                  },
                  macos: {
                     justifyContent: 'space-between',
                  },
               }),
            },
            // isWeb &&
            //    !isLandscapeMode &&
            //    !isLandscapeSmallWebView && {
            //       ...Platform.select({
            //          web: {
            //             height: '100vw',
            //             top: '100vh',
            //             left: 0,
            //             transform: 'rotate(-90deg)',
            //             transformOrigin: 'left top',
            //             width: '100vh',
            //          },
            //       }),
            //    },
            // isWeb &&
            //    isLandscapeSmallWebView && {
            //       ...Platform.select({
            //          web: {
            //             height: '100vh',
            //             top: 0,
            //             left: '100vh',
            //             transform: 'rotate(90deg)',
            //             transformOrigin: 'left top',
            //             width: '100vw',
            //          },
            //       }),
            //    },
         ]}>
         <StatusBar
            // style={{
            //    width: 100,
            //    height: 20,
            //    backgroundColor: 'red',
            // }}
            hidden={true}
         />
         {isWindows && isVideo && (
            <TextInput
               autoFocus={true}
               onKeyPress={handleKeyDown}
               ref={inputRef}
               style={{width: 0, height: 0}}
            />
         )}
         {isVideo ? (
            <TouchableWithoutFeedback
               style={[
                  styles.overlay,
                  {
                     ...Platform.select({
                        web: {
                           flex: null,
                        },
                     }),
                  },
               ]}
               onPress={handleKeyDown}>
               <View
                  style={[
                     styles.overlay,
                     {
                        height:
                           isWindows && isLandscapeMode
                              ? '84%'
                              : isMacos
                              ? '89%'
                              : '100%',
                        flex: isWindows ? 1 : null,
                        ...Platform.select({
                           web: {
                              width: '100%',
                              height: isLandscapeMode
                                 ? webLandscapeVideoHeight
                                 : '100%',
                              maxHeight: isLandscapeMode ? null : '100vh',
                           },
                        }),
                     },
                  ]}>
                  {!isDesktop ? (
                     isWeb ? (
                        <Video
                           ref={videoRef}
                           url={videoSource.uri}
                           controls={false}
                           playing={isPlaying}
                           onReady={handleReadyWeb}
                           style={{
                              position: 'absolute',
                              maxWidth: '100vw',
                              maxHeight: '99vh',
                           }}
                           onProgress={handleProgress}
                           onDuration={handleDuration}
                           onStart={hideControl}
                           onEnded={nextSlide}
                           onBuffer={handleBuffer}
                           volume={volume}
                           width={'100%'}
                           height={'100%'}
                           onClick={() => setShowControl(true)}
                           config={{
                              file: {
                                 attributes: {
                                    controlsList: 'nodownload',
                                    playsInline: true,
                                 },
                              },
                           }}
                        />
                     ) : (
                        <Video
                           source={videoSource}
                           ref={videoRef} // Store reference
                           //   onBuffer={this.onBuffer} // Callback when remote video is buffering
                           //   onError={this.videoError} // Callback when video cannot be loaded
                           style={[
                              styles.backgroundVideo,
                              {
                                 alignSelf: 'center',
                              },
                              {
                                 width: screenLandscapeWidth,
                                 height: screenLandscapeHeight,
                              },
                              !isAndroid && {
                                 orientation: 'landscape',
                              },
                           ]}
                           paused={!isPlaying}
                           resizeMode="contain"
                           volume={volume}
                           fullscreen={false}
                           onEnd={nextSlide}
                           onLoad={onLoad}
                           onBuffer={handleBuffer}
                           onProgress={onProgress}
                           onLayout={onLayout}
                           // onSeek={data => setCurrentTime(data.seekTime)}
                        />
                     )
                  ) : (
                     <WebView
                        onLayout={onLayout}
                        ref={webViewRef}
                        style={[
                           styles.backgroundVideo,
                           {
                              alignSelf: 'center',
                           },
                           {
                              width: screenLandscapeWidth,
                              height: screenLandscapeHeight,
                           },
                           !isAndroid && {
                              orientation: 'landscape',
                           },
                        ]}
                        allowsInlineMediaPlayback
                        allowsFullscreenVideo
                        useWebKit={isWindows ? true : null}
                        onLoadEnd={onLoadEnd}
                        javaScriptEnabled={true}
                        onLoad={() => {
                           if (isWindows) {
                              // Add the event listener for receiving messages from the web content
                              webViewRef.current.injectJavaScript(`
                           window.addEventListener('message', function(event) {
                             document.external.notify(event.data);  
                           });
                         `);
                           }
                        }}
                        onMessage={event => {
                           if (Platform.OS === 'windows') {
                              const {data} = event.nativeEvent;
                              const metadata = JSON.parse(data);
                              if (metadata.type === 'progress') {
                                 winFocus();
                                 setCurrentTime(metadata.payload.currentTime);
                                 setVideoHeight(metadata.payload.videoHeight);
                                 setVideoWidth(metadata.payload.videoWidth);
                                 tigerTheCourseEvent(currentTime);
                                 setDuration(metadata.payload.duration);
                              }

                              if (metadata.type === 'metadata') {
                                 // setDuration(metadata.payload.duration);
                                 onLoadMacVideo(metadata.payload);
                              }

                              if (metadata.type === 'ended') {
                                 if (currentSlide < totalSlide - 1) {
                                    var slide = currentSlide;
                                    changeSlideData(slide + 1);
                                    setDuration(0);
                                 }
                              }

                              if (metadata.type === 'onplaying') {
                                 setVolumeForMac(volume);
                              }
                           } else {
                              // Event for mac os
                              const {data} = event.nativeEvent;
                              if (!isNaN(data)) {
                                 setCurrentTime(parseFloat(data));
                                 tigerTheCourseEvent(currentTime);
                              }
                              const message = JSON.parse(data);

                              if (message.event === 'VideoEnded') {
                                 logger('video ends');
                                 if (currentSlide < totalSlide - 1) {
                                    var slide = currentSlide;
                                    changeSlideData(slide + 1);
                                    setDuration(0);
                                 }
                              }
                              /////
                              // Parse the message data
                              const jsonObj = JSON.parse(data);
                              if (
                                 jsonObj.duration !== 'undefined' &&
                                 jsonObj.width !== 'undefined' &&
                                 jsonObj.height !== 'undefined'
                              ) {
                                 onLoadMacVideo(JSON.parse(data));
                              }
                              //
                              if (message.event === 'VideoLoaded') {
                                 setVolumeForMac(volume);
                              }
                           }
                        }}
                        injectedJavaScript={
                           isMacos
                              ? `
                        const video = document.getElementById('norcatVideo');
                        
                        function sendMessage() {
                          window.ReactNativeWebView.postMessage(video.currentTime.toString());
                        }
                        //For showing progress slider
                        video.addEventListener('timeupdate', sendMessage);
        
                        function sendVideoloadMessage() {
                          // Get video duration, width, and height
                          var duration = this.duration;
                          var width = this.videoWidth;
                          var height = this.videoHeight;
                          
                
                          //For setting the duration, height and widht of the video
                          window.ReactNativeWebView.postMessage(JSON.stringify({ duration, width, height }));
                        }
        
                        document.querySelector('video').addEventListener('loadedmetadata', sendVideoloadMessage);
        
                        document.querySelector('video').addEventListener('ended', function() {
                        // Post a message back to the WebView when the video ends
                        window.ReactNativeWebView.postMessage(JSON.stringify({event :'VideoEnded'}));
                        });

                        document.querySelector('video').addEventListener('loadeddata', function() {
                           // Post a message back to the WebView when the video ends
                           window.ReactNativeWebView.postMessage(JSON.stringify({event :'VideoLoaded'}));
                           });
                      `
                              : 'null'
                        }
                        source={{
                           html: isWindows
                              ? `
                   <video id="norcatVideo"
                     style="width: 100%; height: 105%; background-color:black;"
                     autoplay
                     oncanplaythrough="window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'metadata', payload: { duration: this.duration, videoWidth: this.videoWidth, videoHeight: this.videoHeight } }));"
                     ontimeupdate="window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'progress', payload: { currentTime: this.currentTime, duration: this.duration, videoWidth: this.videoWidth, videoHeight: this.videoHeight} }));"
                     onended="window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'ended' }));"   
                     onplaying="window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'onplaying' }));"   
                     onkeydown=""window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'onkeypress' }));"
                     src="${videoSource.uri}"
                   />
                 `
                              : `
                 <video id="norcatVideo"
                   style="width: 100%; height: 100%; background-color: black;"
                   autoplay
                   src="${videoSource.uri}"
                 />
               `,
                        }}
                     />
                  )}
                  {isWindows ? (
                     <TouchableOpacity
                        style={[styles.overlay, {position: 'absolute'}]}
                        onPress={() => handleControls()}
                     />
                  ) : null}
               </View>
            </TouchableWithoutFeedback>
         ) : (
            <View
               style={[
                  styles.overlay,
                  {
                     height:
                        (isWindows || isWeb) && isLandscapeMode && !isFinaltest
                           ? '84%'
                           : isMacos
                           ? '89%'
                           : '100%',
                     flex: isWindows ? 1 : null,
                  },
               ]}>
               <View
                  style={{
                     flex: 1,
                     ...Platform.select({
                        web: {
                           flex: null,
                           height: isFinaltest
                              ? '100%'
                              : isLandscapeSmallWebView
                              ? '85%'
                              : isLandscapeMode
                              ? '100%'
                              : '90%',
                        },
                     }),
                  }}>
                  {finalQuesAnsData && (
                     <ReviewQuestionScreen
                        finalQuesAnsData={finalQuesAnsData}
                        isReviewTest={isReviewTest}
                        moduleIndex={moduleIndex}
                        currentSlide={currentSlide}
                        percentageRequirement={percentageRequirement}
                        onNextPress={() => {
                           nextSlide();
                        }}
                        onBeginTest={() => {
                           //To handle Tutorial view
                           setFinalTestStarted(true);
                        }}
                        isFinalTest={isFinaltest}
                        closeFullscreen={closeFullscreen}
                        isPreTeastEnable={isPreTeastEnable}
                        titleHancler={webTitle => {
                           setWebTitle(webTitle);
                        }}
                        onMediaClicked={() => {}}
                     />
                  )}
                  {isTutorialVisible && (isReviewTest || isFinalTestStarted) ? (
                     <TutorialOverlayView
                        hideOverlay={() => {
                           setIsTutorialVisible(false);
                           storeAppData(TutorialShown, 'false');
                        }}
                     />
                  ) : null}
               </View>
               {!isFinaltest &&
                  !((isWindows || isDesktop || isWeb) && isLandscapeMode) && (
                     <View style={{backgroundColor: '#202020'}}>
                        <BottomControll
                           duration={duration}
                           currentTime={currentTime}
                           isPlaying={isPlaying}
                           volume={volume}
                           totalSlide={totalSlide}
                           showControl={showControl}
                           currentSlide={currentSlide}
                           isVideo={isVideo}
                           slideTitle={title}
                           // onValueChange={value => {
                           //    seekTO(value);
                           // }}
                           onFeedbackClick={() => {
                              setWebTitle('Feedback');
                              if (isVideo) {
                                 setIsPlaying(false);
                                 pauseMacVideo();
                              }
                              setShowFeedBackScreen(true);
                              setShowControl(false);
                           }}
                           onVolumeChage={value => {
                              handleVolumeChange(value);
                           }}
                           onHomePress={() => {
                              if (isPlaying) {
                                 handlePlayPause();
                              }
                              if (isWeb && isFullScreen) {
                                 closeFullscreen();
                              }
                              if (Platform.OS === 'windows') {
                                 dispatch(setIsEnrolledPageReload(false));
                                 dispatch(setIsDashboardRefreshRequired(true));
                              }
                              navigation.pop(2);
                              //To do land back on Course details
                           }}
                           onListPress={() => {
                              if (isPlaying) {
                                 handlePlayPause();
                              }
                              if (isWeb && isFullScreen) {
                                 closeFullscreen();
                              }
                              goBackToSlides();
                           }}
                           isQuesTestScreen={true}
                           toggleFullScreen={toggleFullScreen}
                           // props for slider:
                           value={currentTime}
                           minimumValue={0}
                           {...(!isWeb && {
                              onSeekBarValueChange: value =>
                                 onValueChange(value),
                           })}
                           {...(isWeb && {
                              onSeekBarSlidingComplete: value =>
                                 onValueChange(value),
                           })}
                           disabled={!isNextSlideAvailable}
                           maximumValue={duration}
                           thumbTouchSize={{width: 15, height: 15}}
                           thumbStyle={{height: 15, width: 15}}
                           minimumTrackTintColor="#6E8EFF"
                           maximumTrackTintColor="#CECECE"
                           trackStyle={{
                              height: 8,
                              borderRadius: 5,
                              backgroundColor: '#585858',
                           }}
                           style={{
                              height: 12,
                              padding: 0,
                              marginVertical: 0,
                              marginHorizontal: 4,
                              marginTop: 8,
                              ...Platform.select({
                                 web: {
                                    cursor: 'pointer',
                                 },
                              }),
                           }}
                           thumbTintColor={'#6E8EFF'}
                           isReviewTest={isReviewTest && !isVideo}
                           isFullScreen={isFullScreen}
                        />
                     </View>
                  )}
            </View>
            // </TouchableWithoutFeedback>
         )}

         {showOverlay && isVideo && eventNode.length > 0 ? (
            <TouchableWithoutFeedback
               onPress={() => (!isWeb ? handleControls() : null)}>
               <View
                  style={{
                     width: '100%',
                     height: '100%',
                     position: 'absolute',
                  }}>
                  <CourseSlideEventOnVideo
                     pdata={eventNode}
                     dimentionData={{
                        videoDimention: {
                           width: videoWidth,
                           height: videoHeight,
                        },
                        playerDimention: {
                           width: playerWidth,
                           height: playerHeight,
                        },
                     }}
                     currentTime={currentTime}
                     eventCallcack={couseEventCallBack}
                  />
               </View>
            </TouchableWithoutFeedback>
         ) : null}
         {/* {showControl && isVideo && ( */}
         {showControl && isVideo ? (
            <CustomController
               duration={duration}
               isSlideAvailable={isNextSlideAvailable}
               currentTime={currentTime}
               isPlaying={isPlaying}
               volume={volume}
               totalSlide={totalSlide}
               showControl={showControl}
               currentSlide={currentSlide}
               isVideo={isVideo}
               title={course.courseTitle || ''}
               onPlayPauseClick={handlePlayPause}
               previousSlide={previousSlide}
               nextSlide={nextSlide}
               slideTitle={title}
               fullscreenClick={() => {
                  showControl(!showControl);
               }}
               {...(!isWeb && {
                  onSeekBarValueChange: onValueChange,
               })}
               {...(isWeb && {
                  onSeekBarSlidingComplete: onValueChange,
               })}
               disabled={!isNextSlideAvailable}
               onFeedbackClick={() => {
                  if (isVideo) {
                     setIsPlaying(false);
                     pauseMacVideo();
                  }
                  setShowFeedBackScreen(true);
                  setShowControl(false);
               }}
               onVolumeChage={value => {
                  handleVolumeChange(value);
               }}
               onHomePress={() => {
                  if (isPlaying) {
                     handlePlayPause();
                  }
                  if (isWeb && isFullScreen) {
                     closeFullscreen();
                  }
                  if (Platform.OS === 'windows') {
                     dispatch(setIsDashboardRefreshRequired(true));

                     dispatch(setIsEnrolledPageReload(false));
                  }
                  navigation.pop(2);
                  //To do land back on Course details
               }}
               onListPress={() => {
                  if (isPlaying) {
                     handlePlayPause();
                  }
                  if (isWeb && isFullScreen) {
                     closeFullscreen();
                  }
                  goBackToSlides();
               }}
               rewind={() => previousSlide()}
               forward={() => nextSlide()}
               toggleFullScreen={toggleFullScreen}
               handleControls={() => handleControls()}
               // props for seekbar slider:
               value={currentTime}
               minimumValue={0}
               maximumValue={duration}
               thumbTouchSize={{width: 15, height: 15}}
               thumbStyle={{height: 15, width: 15}}
               minimumTrackTintColor="#6E8EFF"
               maximumTrackTintColor="#CECECE"
               trackStyle={{
                  height: 8,
                  borderRadius: 5,
                  backgroundColor: '#585858',
               }}
               style={{
                  height: 12,
                  padding: 0,
                  marginVertical: 0,
                  marginHorizontal: 4,
                  marginTop: 8,
                  ...Platform.select({
                     web: {
                        cursor: 'pointer',
                     },
                  }),
               }}
               thumbTintColor={'#6E8EFF'}
               isReviewTest={isReviewTest && !isVideo}
            />
         ) : null}
         {!isFinaltest &&
            (isWindows || isDesktop || isWeb) &&
            isLandscapeMode && (
               <>
                  {/* </View> */}

                  <BottomControll
                     duration={duration}
                     currentTime={currentTime}
                     isPlaying={isPlaying}
                     volume={volume}
                     totalSlide={totalSlide}
                     showControl={showControl}
                     currentSlide={currentSlide}
                     isVideo={isVideo}
                     // onValueChange={value => {
                     //    seekTO(value);
                     // }}
                     focusWin={() => {
                        winFocus();
                     }}
                     onFeedbackClick={() => {
                        setWebTitle('Slide Feedback');
                        if (isVideo) {
                           setIsPlaying(false);
                           pauseMacVideo();
                        }
                        setShowFeedBackScreen(true);
                        setShowControl(false);
                        winFocus();
                     }}
                     onVolumeChage={value => {
                        handleVolumeChange(value);
                        winFocus();
                     }}
                     onHomePress={() => {
                        if (isPlaying) {
                           handlePlayPause();
                        }
                        if (isWeb && isFullScreen) {
                           closeFullscreen();
                        }
                        if (Platform.OS === 'windows') {
                           dispatch(setIsEnrolledPageReload(false));
                           setIsDashboardRefreshRequired;
                        }
                        navigation.pop(2);
                        //To do land back on Course details
                     }}
                     onListPress={() => {
                        if (isPlaying) {
                           handlePlayPause();
                        }
                        if (isWeb && isFullScreen) {
                           closeFullscreen();
                        }
                        goBackToSlides();
                     }}
                     previousSlide={previousSlide}
                     nextSlide={nextSlide}
                     onPlayPauseClick={handlePlayPause}
                     isNextEnable={isNextSlideAvailable}
                     slideTitle={title}
                     toggleFullScreen={toggleFullScreen}
                     // props for seekbar slider:
                     value={currentTime}
                     minimumValue={0}
                     {...(!isWeb && {
                        onSeekBarValueChange: value => onValueChange(value),
                     })}
                     {...(isWeb && {
                        onSeekBarSlidingComplete: value => onValueChange(value),
                     })}
                     disabled={!isNextSlideAvailable}
                     maximumValue={duration}
                     thumbTouchSize={{width: 15, height: 15}}
                     thumbStyle={{height: 15, width: 15}}
                     minimumTrackTintColor="#6E8EFF"
                     maximumTrackTintColor="#CECECE"
                     trackStyle={{
                        height: 8,
                        borderRadius: 5,
                        backgroundColor: '#585858',
                     }}
                     style={{
                        height: 12,
                        padding: 0,
                        marginVertical: 0,
                        marginHorizontal: 4,
                        marginTop: 8,
                        ...Platform.select({
                           web: {
                              cursor: 'pointer',
                           },
                        }),
                     }}
                     thumbTintColor={'#6E8EFF'}
                     isReviewTest={isReviewTest && !isVideo}
                     isFullScreen={isFullScreen}
                  />
               </>
            )}
         {isLoading && (
            <View
               style={{
                  width: '100%',
                  height: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'absolute',
               }}>
               <ActivityIndicator size="large" color={ActivityLoaderColor} />
            </View>
         )}
         {showFeedBackScreen && (
            <View
               style={{
                  width: '100%',
                  height: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'absolute',
               }}>
               <FeedBackView
                  courseData={{
                     moduleId: moduleId,
                     slid: currentSlide + 1,
                     norcatid: authData.OCGCTNorcat_ID,
                     courseName: course.courseData.coursename,
                     modulePageNumber: pageNumber,
                  }}
                  onClose={() => {
                     if (isVideo) {
                        setIsPlaying(true);
                     }
                     setShowFeedBackScreen(false);
                     setShowControl(true);
                  }}
               />
            </View>
         )}
         {showAlertData?.showAlert && (
            <CustomAlert
               title={showAlertData.title}
               message={showAlertData.message}
               onOK={showAlertData.callback}
            />
         )}
         {isWeb &&
            !isLandscapeMode &&
            isMobile &&
            !isFullScreen &&
            !isLandscapeSmallWebView &&
            !isAndroidFullScreen && (
               <CustomToast message={rotatePlayerScreenMsg} />
            )}
         <NorcatWebAlert
            isApiLoading={isApiLoading}
            showAlert={isMCOnPlayerScreen}
            message={message}
            onCallBack={() => {
               refreshEnrolledCourses();
            }}
         />
      </View>
   );

   function navigateToWebView(path, navigation) {
      if (Platform.OS === 'macos') {
         navigation.navigate('WebViewContainerMacos', {
            urlPath: path,
            isShowingByBase64Str: false,
            sharingEnabled: false,
         });
      } else {
         navigation.navigate('WebViewContainer', {
            urlPath: path,
            isShowingByBase64Str: false,
            sharingEnabled: false,
            title: 'Media',
         });
      }
   }

   function couseEventCallBack(params) {
      const eventInteraction = params;
      const interatableType = parseInt(
         eventInteraction.courseSlideElementImage.interatableType,
      );
      switch (interatableType) {
         case 1:
            if (
               isAndroid &&
               eventInteraction.courseSlideElementImage.customURL.endsWith(
                  '.pdf',
               )
            ) {
               Linking.openURL(
                  'https://docs.google.com/gview?embedded=true&url=' +
                     eventInteraction.courseSlideElementImage.customURL,
               );
            } else if (isWindows || isWeb || isMacOS || isiOS) {
               Linking.openURL(
                  eventInteraction.courseSlideElementImage.customURL,
               );
               pauseMacVideo();
            } else {
               navigateToWebView(
                  eventInteraction.courseSlideElementImage.customURL,
                  navigation,
               );
            }
            /*navigation.navigate('WebViewContainer', {
          urlPath: eventInteraction.courseSlideElementImage.customURL,
          isShowingByBase64Str: false,
          sharingEnabled: false,
        });*/
            break;
         case 2:
            setShowOverlay(false);
            nextSlide();
            break;
         case 3:
            setShowOverlay(false);
            setIsContinueTiered(true);
            setIsPlaying(true);
            playMacVideo();
            break;
      }
   }
};

var styles = StyleSheet.create({
   container: {backgroundColor: '#000000', flex: 1},

   backgroundVideo: {
      position: isMacos || isWindows ? null : 'absolute',
      backgroundColor: isMacos ? 'transparent' : '#000000',
   },
   overlay: {
      width: '100%',
      height: '100%',
      ...Platform.select({
         web: {
            display: 'flex',
            justifyContent: 'space-between',
         },
         // macos: {
         //    flex: 1,
         // },
         // windows: {
         //    flex: 1,
         // },
      }),
   },
   videoWebStyles: {
      width: '100vw',
      height: '100%',
   },
});

export default PlayerScreen;
